import { consts } from '../common/modals/consts';
import { IOperativeTypeInfo } from "./operative-type.interface";

export class OperativeTypeInfo implements IOperativeTypeInfo {
  id: string;
  name: string;
  description: string;
  isSelected: boolean;


  constructor(iOperativeTypeInfo: IOperativeTypeInfo = null) {
    this.id = iOperativeTypeInfo?.id || consts.emptyGuid;
    this.name = iOperativeTypeInfo?.name || "";
    this.description = iOperativeTypeInfo?.description || "";
    this.isSelected = iOperativeTypeInfo?.isSelected || false;
  }  
}
